var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3BLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0.545 16.591H23.520000000000003V24.371000000000002H0.545z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002447",
    d: "M5.693 9.254L5.693 24.553"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002447",
    d: "M18.19 9.288L18.19 24.587"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#99a7b4",
    fillOpacity: 1,
    strokeWidth: 0.784,
    d: "M0.806 1.662H5.316V16.294H0.806z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.555 1.662H15.895V16.294H8.555z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.18 1.662H23.52V16.294H16.18z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002447",
    d: "M0.183 16.555L23.52 16.555"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002447",
    d: "M5.704 1.476L5.704 16.775"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002447",
    d: "M18.195 1.011L18.195 16.31"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#002447",
    d: "M0.5 1.333H23.5V24.333H0.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3BLeft);
export default __webpack_public_path__ + "static/media/3b_left.ba2f6866cec16669ef97bc9b1b0b7e16.svg";
export { ForwardRef as ReactComponent };